import { Box } from '@mui/material'
import AppDrawer from './components/drawer'
import Header from './components/header'
import ImacrosGenerator from "./imacros-generator"

const App = () => {

  return (
    <Box sx={{ display: "flex", height: "100vh", flexDirection: "column", overflow: "hidden" }}>
      <AppDrawer/>
      <Header/>
      <ImacrosGenerator/>
    </Box>
  )
}

export default App